module.exports = __webpack_public_path__ + "static/img/sh.389ea7a3.png";